/** Earliest day selectable in Compliance Explore (date picker UI + API request clamping). */
export const COMPLIANCE_EARLIEST_SELECTABLE_DATE = '2026-01-01';
